module.exports = __webpack_public_path__ + "static/babynames-0d1162d604256c45a7b05fad5bf52574.png";